var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFanzpicks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_63592",
    "data-name": "Group 63592",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 536,
    height: 86.298,
    viewBox: "0 0 536 86.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.388,
    y1: -1.513,
    x2: 0.609,
    y2: 1.857,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2553c8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53612",
    "data-name": "Path 53612",
    d: "M50.343,159.817H18.952v15.991h30.8v18.237h-30.8V224.5H0V141.58H50.343v18.237Z",
    transform: "translate(0 -139.877)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53613",
    "data-name": "Path 53613",
    d: "M81.835,224.5l-4.442-13.03H45.485L41.339,224.5H20.61L48.792,141.58H72.951L101.207,224.5h-19.4Zm-30.6-30.8H71.323L60.933,163.247,51.21,193.7Z",
    transform: "translate(30.251 -139.877)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53614",
    "data-name": "Path 53614",
    d: "M102.357,141.58h18.952V224.5H107.095L75.112,179.485V224.5H56.16V141.58H70.374l31.982,45.012V141.58Z",
    transform: "translate(82.43 -139.877)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53615",
    "data-name": "Path 53615",
    d: "M111.418,206.26h32.328V224.5H87.11V209.814l31.736-50H87.7V141.58h55.5v14.585l-31.81,50.1Z",
    transform: "translate(127.858 -139.877)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53616",
    "data-name": "Path 53616",
    d: "M145.63,141.58a28.237,28.237,0,0,1,20.606,8.292,28.3,28.3,0,0,1,0,40.274,28.238,28.238,0,0,1-20.606,8.292H133.192V224.5H114.24V141.58h31.39Zm0,39.09a9.457,9.457,0,0,0,7.231-3.085,11.531,11.531,0,0,0,0-15.152,9.42,9.42,0,0,0-7.231-3.085H133.192v21.321H145.63Z",
    transform: "translate(167.678 -139.877)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53617",
    "data-name": "Path 53617",
    d: "M142.56,141.58h18.952V224.5H142.56V141.58Z",
    transform: "translate(209.245 -139.877)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53618",
    "data-name": "Path 53618",
    d: "M197.672,227.163q-18.619,0-30.847-12.388-12.253-12.364-12.265-30.748,0-18.36,12.265-30.748,12.252-12.364,30.847-12.388a42.482,42.482,0,0,1,20.606,5.158,38.958,38.958,0,0,1,14.93,14.042l-16.337,9.476a18.721,18.721,0,0,0-7.823-7.527,24.171,24.171,0,0,0-11.376-2.665c-7.354,0-13.2,2.246-17.6,6.762s-6.564,10.463-6.564,17.891,2.2,13.375,6.564,17.891,10.241,6.762,17.6,6.762a24.177,24.177,0,0,0,11.426-2.715,18.391,18.391,0,0,0,7.749-7.453l16.337,9.476a38.1,38.1,0,0,1-14.807,14.042,42.752,42.752,0,0,1-20.729,5.158Z",
    transform: "translate(226.859 -140.89)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53619",
    "data-name": "Path 53619",
    d: "M257.079,224.5H235.511l-26.529-38.3v38.3H190.03V141.58h18.952v36l25.344-36h21.568l-27.96,40.4,29.144,42.52Z",
    transform: "translate(278.921 -139.877)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanzpicks);
export default __webpack_public_path__ + "static/media/fanzpicks.bb1bce07fbdfcc001a05f1fe1ad76a0a.svg";
export { ForwardRef as ReactComponent };